<script>
    import { fade } from 'svelte/transition';
    import { authenticationState, accessToken, user } from '../stores';
    import { apiUrl, clientId, clientSecret } from '../discord';
    import { auth } from '../firebase';
	import Debug from './debug';
    
    // See comments for Date.now() vs new Date().getTime(): https://stackoverflow.com/a/8809472/3403247
    function generateUUID() { // Public Domain/MIT
        var d = Date.now();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    // TOOD: is this ok?
    const redirectURI = encodeURIComponent(`${window.location.origin}/auth/discord`);

    // See: https://discordapp.com/developers/docs/topics/oauth2
    // Generate by hashing user's session cookie?  How would that be better
    const state = generateUUID();
    $authenticationState = state;
    // TODO: &prompt=none doesn't work?  Supposed to automatically continue if already authorized.  See docs.
    const discordAuthURL = `https://discordapp.com/api/oauth2/authorize?client_id=602971242403725328&state=${state}&redirect_uri=${redirectURI}&response_type=code&scope=identify`;

    let authparams = {
        service: null,
        code: null,
        state: null,
    };
    window.authenticate = function(service, code, state) {
        authparams = { service, code, state };

        if ($authenticationState === authparams.state) {
            // Authenticate!
            // TODO: move this into the authenticated store?  Maybe change to authentication and also store refresh/access token there?  And hydrate it from somewhere safe?  Like some safe storage or server?
            const discordTokenURL = `https://discordapp.com/api/oauth2/token`;
            // According to the Discord developers oauth2 page, content needs to be x-www-form-urlencoded
            // See: https://stackoverflow.com/a/9713078/3403247
            const params = `client_id=${clientId}&client_secret=${clientSecret}&grant_type=authorization_code&code=${authparams.code}&redirect_uri=${redirectURI}d&response_type=code&scope=identify`;
            
            // TODO: fetch?
            const xhr = new XMLHttpRequest();
            // TODO: vs onreadystatechange?
            xhr.onload = () => {
                // Might not need to check this since we're using onload
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    console.log('Done');
                    console.log(xhr.status);
                    console.log(xhr.response);
                    console.log(xhr.response.scope);
                    accessToken.set(xhr.response.access_token);
                    // TODO: probably want to create a user here if they are not already registered with our app, then load from that user and not from Discord API anymore.  unless we _just_ want to use discord..?
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
                    fetch(`${apiUrl}/users/@me`, {
                        headers: new Headers({
                            'Authorization': `Bearer ${$accessToken}`,
                        }),
                    })
                        .then(response => response.json())
                        .then(json => {
                            console.log(json);
                            user.set(json);  // Build this from our own accounts service
                        });
                } else {
                    console.log(`Not done yet (ready state is ${xhr.readyState})`);
                }
            }
            xhr.open('POST', discordTokenURL);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.responseType = 'json';
            xhr.send(params);
        } else {
            console.log(`Authentication state does not match state received from callback\n${$authenticationState}!==${authparams.state}`);
        }
    }
    window.getAuthenticationState = function() {
        return $authenticationState;
    }
</script>

<style>
    button {
        background-color: #7289da;
        color: white;
        border-radius: 3px;
        padding: 7px 14px 7px 16px;
        border: none;
        font-family: Whitney, Helvetica Neue, Helvetica, Arial, sans-serif;
        transition: 0.3s;
        width: auto;
        white-space: nowrap;
        /* width: 100%; */
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    button:hover {
        background-color: #4e5d94;
    }
    img {
        flex: 0;
        height: 28px;
        width: auto;
        padding-top: 2px;
    }
    span {
        margin-right: 5px;
        padding-bottom: 2px;
    }
</style>

<button on:click={() => {
    window.open(discordAuthURL, 'DiscordAuthWindow', 'menubar=no,toolbar=no,top=80,left=60,height=800,width=600');
}}><span>Sign in with</span><img alt="Discord" src="assets/discord/Discord-Logo+Wordmark-White.svg"></button>   

<Debug.Auth authparams/>
